import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.j{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cv{background:var(--shades-white);}.ssr-plugin'
import '.bj{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.ba{max-width:77.5rem;}.ssr-plugin'
import '.dd{justify-content:stretch;}.ssr-plugin'
import '.de{position:sticky;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.df{z-index:10;}.ssr-plugin'
import '.dg{padding-block:1rem;}.ssr-plugin'
import '.dh{height:3rem;}.ssr-plugin'
import '.a5{justify-content:space-between;}.ssr-plugin'
import '.di{flex-wrap:wrap;}.ssr-plugin'
import '.dj{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bh{margin-top:2rem;}.ssr-plugin'
import '.g3{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab j b cv"
      >
        <div className="bj a c j b"
        >
          <div className="ba a b dd de cj df"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="dg dh a a5 c di"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="dj a b ab bh g3 ba"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
